import { z } from 'zod';

export const syncedChatInstanceModel = z.object({
  id: z.number(),
  identifier: z.string(),
  userIdentifier: z.string(),
  name: z.string().nullable(),
  isDeleted: z.boolean(),
  createdAt: z.coerce.date(),
  contextData: z.unknown()
});

export const syncedChatInstanceQueryModel = z.object({
  id: z.number(),
  identifier: z.string(),
  chatInstanceId: z.number(),
  value: z.string(),
  rating: z.number().nullable(),
  createdOn: z.coerce.date(),
  structuredFeedback: z.unknown(),
  notes: z.string().nullable(),
  feedbackUpdatedOn: z.coerce.date().nullable(),
  citations: z.unknown().array(),
  response: z.unknown(),
  parentIdentifier: z.string().nullable(),
  contextData: z.unknown(),
  suggestedFollowups: z.string().array(),
});

export const chatSyncDataPayloadModel = z.object({
  chatInstances: z.array(syncedChatInstanceModel),
  chatQueries: z.array(syncedChatInstanceQueryModel),
});